import { Shadows } from "@mui/material/styles/shadows";

import { e } from "@/federal-ci/theme";

export const shadows = e as Shadows;
